import { createAxios } from '../lib/axiosFactory';
import { errorParser } from '../lib/response/errorParser';
import { ActionResponse } from '../lib/interfaces/actionResponse';

export const state = () => ({
  calculatingRemainingCredits: false
});

export const mutations = {
  setCalculatingRemainingCredits(
    state: any,
    { calculatingRemainingCredits }: { calculatingRemainingCredits: boolean }
  ): void {
    state.calculatingRemainingCredits = calculatingRemainingCredits;
  }
};

export const getters = {
  calculatingRemainingCredits(state: any): boolean {
    return state.calculatingRemainingCredits;
  }
};

export const actions = {
  async sendTestSms(
    { commit, rootState },
    { campaignId, payload }
  ): Promise<ActionResponse> {
    try {
      const response: any = await createAxios().post(
        '/backend/campaign-test-sms-create',
        {
          data: {
            type: 'testSms',
            attributes: payload
          }
        },
        {
          params: {
            clientId: rootState.user.clientId,
            campaignId
          }
        }
      );

      commit(
        'campaign/setTestSmsSentAt',
        { testSmsSentAt: response.data.data.attributes.testSmsSentAt },
        { root: true }
      );

      return { success: true, errors: {}, body: response.data };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  }
};
